import { AuthenticatedService } from "../abstract/base.service";
import { ListResponse } from "@/models/grids/list.response";
import { CreateActivityCommentCommand } from "@/server/app.commands";
import { ActivityCommentDto } from "@/server/app.dtos";
import { GetActivityCommentsDtosQuery } from "@/server/app.queries";

export class ActivitiesCommentsService extends AuthenticatedService {
  CreateComment(comment: CreateActivityCommentCommand): Promise<number> {
    return this.Post(
      `${this.baseUrl}api/activities/${comment.idActivity}/comments`,
      comment
    );
  }

  GetComments(
    request: GetActivityCommentsDtosQuery
  ): Promise<ListResponse<ActivityCommentDto>> {
    return this.Get(
      `${this.baseUrl}api/activities/${
        request.idActivity
      }/comments?${this.GetQueryStringByObject(request)}`
    );
  }
}
